module.exports = __webpack_public_path__ + "img/podrska.489c017d.png";